import UserListContainer from './UserListContainer';

export default UserListContainer;
